import { render, staticRenderFns } from "./3dViewer.vue?vue&type=template&id=af6c1ce0&scoped=true&"
import script from "./3dViewer.vue?vue&type=script&lang=js&"
export * from "./3dViewer.vue?vue&type=script&lang=js&"
import style0 from "./3dViewer.vue?vue&type=style&index=0&id=af6c1ce0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af6c1ce0",
  null
  
)

export default component.exports